/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';

export const LoadedCompContext = createContext<any>({});

export const useLoadedCompContext = () => {
  return useContext(LoadedCompContext);
};
